import React, { useState } from "react";
import Heading from "../Components/Heading";
import { useTheme } from "../Context/ThemeContext";
import Layout from "../Layout";

function Experience() {
    const { primaryColor, secondaryColor, theme, selectedColor, colors } =
        useTheme();

    const [active, setActive] = useState(0);

    return (
        <Layout>
            <div className="mx-4" data-aos="fade-up">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
                    <div className="md:col-span-2">
                        <div className="">
                            <Heading heading="Experience" />
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-5 mt-5 md:pt-5 gap-3">
                    <div className="md:col-span-1">
                        <div className="flex md:flex-col md:justify-center">
                            <div
                                className={`select-none px-4 py-2 font-bold cursor-pointer ${
                                    active === 0
                                        ? ` bg-opacity-10 dark:bg-opacity-20 bg-gray-600 ${primaryColor} ${colors[theme].colors[selectedColor].borderPrimary} `
                                        : ` ${secondaryColor} ${colors[theme].colors[selectedColor].borderSecondary} `
                                } border-b-2 md:border-0 md:border-l-2 transition-all duration-300`}
                                onClick={() => setActive(0)}
                            >
                                Presidio
                            </div>
                            <div
                                className={`select-none px-4 py-2 font-bold cursor-pointer ${
                                    active === 1
                                        ? ` bg-opacity-10 dark:bg-opacity-20 bg-gray-600 ${primaryColor} ${colors[theme].colors[selectedColor].borderPrimary} `
                                        : ` ${secondaryColor} ${colors[theme].colors[selectedColor].borderSecondary} `
                                } border-b-2 md:border-0 md:border-l-2 transition-all duration-300`}
                                onClick={() => setActive(1)}
                            >
                                Tealorca
                            </div>
                        </div>
                    </div>
                    <div className="md:col-span-4">
                        <div
                            className={`mx-3 transition-all ease-in-out duration-100 ${
                                active === 0 ? "block" : "hidden"
                            }`}
                        >
                            <h2 className="my-2">
                                <span
                                    className={`${secondaryColor} text-lg font-bold leading-relaxed`}
                                >
                                    Associate engineer
                                </span>
                                <span
                                    className={`${primaryColor} text-lg font-bold leading-relaxed`}
                                >
                                    {" "}
                                    @{" "}
                                    <span className="hover:underline cursor-pointer">
                                        Presidio
                                    </span>
                                </span>
                            </h2>
                            <p className="my-2">
                                <span
                                    className={`${secondaryColor} text-sm font-semibold leading-relaxed opacity-75`}
                                >
                                    June 2022 - Present
                                </span>
                            </p>
                            <ul className="my-4">
                                <li
                                    className={`flex opacity-90 my-2 ${secondaryColor} leading-relaxed before:content-["▹"] before:block before:mr-2 before:${primaryColor} before:font-extrabold`}
                                >
                                    Need to be updated...
                                </li>
                            </ul>
                        </div>
                        <div
                            className={`mx-3 transition-all ease-in-out duration-100 ${
                                active === 1 ? "block" : "hidden"
                            }`}
                        >
                            <h2 className="my-2">
                                <span
                                    className={`${secondaryColor} text-lg font-bold leading-relaxed`}
                                >
                                    Intern
                                </span>
                                <span
                                    className={`${primaryColor} text-lg font-bold leading-relaxed`}
                                >
                                    {" "}
                                    @{" "}
                                    <span className="hover:underline cursor-pointer">
                                        Tealorca
                                    </span>
                                </span>
                            </h2>
                            <p className="my-2">
                                <span
                                    className={`${secondaryColor} text-sm font-semibold leading-relaxed opacity-75`}
                                >
                                    May 2020 - December 2020
                                </span>
                            </p>
                            <ul className="my-4">
                                <li
                                    className={`flex opacity-90 my-2 ${secondaryColor} leading-relaxed before:content-["▹"] before:block before:mr-2 before:${primaryColor} before:font-extrabold`}
                                >
                                    Developed and maintained code for client
                                    websites primarily using Laravel, Livewire
                                    and Metronic.
                                </li>
                                <li
                                    className={`flex opacity-90 my-2 ${secondaryColor} leading-relaxed before:content-["▹"] before:block before:mr-2 before:${primaryColor} before:font-extrabold`}
                                >
                                    A B2B e-commerce application for a client
                                    that integrates Google Maps and Places as
                                    well as ERP synchronisation with the client
                                    database.
                                </li>
                                <li
                                    className={`flex opacity-90 my-2 ${secondaryColor} leading-relaxed before:content-["▹"] before:block before:mr-2 before:${primaryColor} before:font-extrabold`}
                                >
                                    An application for managing attorney
                                    accounts that allows users to create and
                                    maintain attorney accounts. Data can be
                                    filtered, sorted, and exported as well.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default Experience;
